import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import StickyNav from './components/StickyNav';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ProblemSection from './components/ProblemSection';
import HowItWorksSection from './components/HowItWorksSection';
import ProductChoiceSection from './components/ProductChoiceSection';
import GrapheneSection from './components/GrapheneSection';
import ComparisonSection from './components/ComparisonSection';
import AllInOneSection from './components/AllInOneSection';
import SavingsCalculator from './components/SavingsCalculator';
import SocialProofSection from './components/SocialProofSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import ContactForm from './components/ContactForm';
import GrpGarantieVergelijking from '../../components/GrpGarantieVergelijking';

const GRPThuisbatterijen = () => {
  const scrollToFormulier = (e) => {
    const el = document.getElementById('formulier');
    if (el) {
      e?.preventDefault?.();
      el?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Sectie 1 — Sticky navigatie */}
      <StickyNav />
      {/* Sectie 2 — Hero */}
      <HeroSection />
      {/* Sectie 3 — Trustbar */}
      <TrustBar />
      {/* Sectie 4 — Het probleem: salderen stopt */}
      <ProblemSection />
      {/* Sectie 5 — De oplossing: zo werkt het */}
      <HowItWorksSection />
      {/* Sectie 6 — Productkeuze: grafeen of lithium */}
      <ProductChoiceSection />
      {/* Sectie 7 — Waarom grafeen */}
      <GrapheneSection />
      {/* Sectie 7b — Vergelijking garantievoorwaarden */}
      <GrpGarantieVergelijking ctaHref="#formulier" ctaTekst="Plan een gratis adviesgesprek" onCtaClick={scrollToFormulier} />
      {/* Sectie 8 — Vergelijking met alternatieven */}
      <ComparisonSection />
      {/* Sectie 9 — Alles-in-één pakket */}
      <AllInOneSection />
      {/* Sectie 10 — Besparingsindicatie */}
      <SavingsCalculator />
      {/* Sectie 11 — Social proof */}
      <SocialProofSection />
      {/* Sectie 12 — Aanbod & prijs */}
      <PricingSection />
      {/* Sectie 13 — FAQ */}
      <FAQSection />
      {/* Sectie 14 — Finale CTA + formulier */}
      <ContactForm />
      {/* Mini footer */}
      <footer className="bg-secondary text-secondary-foreground py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center space-x-2">
              <div className="w-7 h-7 bg-primary rounded-md flex items-center justify-center">
                <Icon name="Leaf" size={15} color="white" />
              </div>
              <span className="font-heading font-semibold text-secondary-foreground">
                Verduurzaamwijzer<span className="text-primary">.nu</span>
              </span>
            </div>

            {/* Partner logos */}
            <div className="flex items-center gap-5 text-xs font-caption text-secondary-foreground/60">
              <span>Partners:</span>
              {['GRP Energy', 'ZekerZon']?.map((p) => (
                <span key={p} className="font-heading font-semibold text-secondary-foreground/80">{p}</span>
              ))}
              <a href="#" className="flex items-center space-x-1 text-blue-400 hover:text-blue-300 transition-colors">
                <Icon name="Award" size={12} />
                <span>Kiwa UN 38.3</span>
              </a>
            </div>

            {/* Links */}
            <div className="flex items-center gap-4 text-xs font-caption text-secondary-foreground/60">
              <Link to="/homepage" className="hover:text-secondary-foreground transition-colors">Home</Link>
              <a href="#" className="hover:text-secondary-foreground transition-colors">Privacyverklaring</a>
              <a href="#" className="hover:text-secondary-foreground transition-colors">Cookiebeleid</a>
            </div>
          </div>

          <div className="mt-6 pt-5 border-t border-secondary-foreground/10 text-center text-xs font-caption text-secondary-foreground/40">
            © {new Date()?.getFullYear()} Verduurzaamwijzer.nu · GRP Thuisbatterijen landingspagina · Alle rechten voorbehouden
          </div>
        </div>
      </footer>
      {/* Bottom padding for mobile sticky CTA */}
      <div className="h-14 sm:hidden" />
    </div>
  );
};

export default GRPThuisbatterijen;
